import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=61b1b18e&scoped=true&"
import script from "./TemplateSelector.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=61b1b18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1b18e",
  null
  
)

export default component.exports